import { buildLoader } from '../util/GenericLoader';
import { getNotificationPrefsAction } from '../../redux/actions/rtemFiles';

export default buildLoader(getNotificationPrefsAction);
